import { Provider } from 'react-redux';
import { AppRouter } from './routers/AppRouter';
import { ToastContainer } from 'react-toastify';
import './App.css';
import { store } from './global/store';

function App() {
  return (
    <Provider store={store}>
      <AppRouter />
      <ToastContainer />
    </Provider>
  );
}

export default App;
